export const PLAN_CODES = {
  starter: "INDIVIDUAL_STARTER",
  pro: "INDIVIDUAL_PRO",
  elite: "INDIVIDUAL_ELITE",
};

const LEGACY_PLAN_CODES = {
  starter: "INDIVIDUAL_MONTHLY",
  pro: "INDIVIDUAL_MONTHLY_19",
};

export const PAID_PLAN_CODES = new Set([PLAN_CODES.pro, PLAN_CODES.elite]);

export function normalizePlanText(value) {
  return String(value || "").trim().toLowerCase();
}

export function isStarterPlanCode(planCode, planLabel = "") {
  const normalizedLabel = normalizePlanText(planLabel);
  return (
    planCode === PLAN_CODES.starter ||
    planCode === LEGACY_PLAN_CODES.starter ||
    normalizedLabel.includes("starter")
  );
}

export function isPaidPlanCode(planCode, planLabel = "") {
  const normalizedLabel = normalizePlanText(planLabel);
  return (
    PAID_PLAN_CODES.has(planCode) ||
    planCode === LEGACY_PLAN_CODES.pro ||
    normalizedLabel.includes("pro") ||
    normalizedLabel.includes("elite")
  );
}

export function canUseTrainingPlans(planCode, planLabel = "") {
  return isPaidPlanCode(planCode, planLabel);
}

export function formatPlanLabel({ rawLabel, planCode, betaFeatureEnabled = false }) {
  const fallback = planCode || "Starter";
  const label = String(rawLabel || fallback).replace(/^\w/, (c) => c.toUpperCase());
  return betaFeatureEnabled && isStarterPlanCode(planCode, label) ? "Beta" : label;
}
